// extracted by mini-css-extract-plugin
export var aiStarIcon = "_kv-2";
export var container = "_kv-4";
export var dismissButton = "_kv-3";
export var hasPaddingBottom = "_kv-6";
export var last = "_kv-e";
export var scrollbarThumb = "_kv-c";
export var scrollbarTrack = "_kv-b";
export var selected = "_kv-9";
export var spin = "_kv-1";
export var spinning = "_kv-0";
export var suggestionItem = "_kv-d";
export var suggestionsPanel = "_kv-5";
export var tonePill = "_kv-8";
export var tonesContainer = "_kv-7";
export var unselected = "_kv-a";